import React from 'react';

function TagUser(props: object) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="24"
        height="24"
        transform="translate(0 0.416992)"
        fill="white"
      />
      <path
        d="M12 16.167C13.6569 16.167 15 14.8238 15 13.167C15 11.5101 13.6569 10.167 12 10.167C10.3431 10.167 9 11.5101 9 13.167C9 14.8238 10.3431 16.167 12 16.167Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 18.417C8.02395 17.7184 8.70336 17.1514 9.48442 16.7608C10.2655 16.3703 11.1267 16.167 12 16.167C12.8733 16.167 13.7345 16.3703 14.5156 16.7608C15.2966 17.1514 15.976 17.7184 16.5 18.417"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 20.667V4.16699C19.5 3.75278 19.1642 3.41699 18.75 3.41699L5.25 3.41699C4.83579 3.41699 4.5 3.75278 4.5 4.16699L4.5 20.667C4.5 21.0812 4.83579 21.417 5.25 21.417H18.75C19.1642 21.417 19.5 21.0812 19.5 20.667Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 6.41699H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default TagUser;
